import type { InvoiceSendingSettings } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

/**
 * Fetches invoice sending settings for a company from the API.
 *
 * @param companyId - The ID of the company to fetch settings for.
 * @returns The invoice sending settings for the company.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Company/operation/get_company_invoice_sending_settings_company__id__invoice_sending_settings_get
 */
export const fetchCompanyInvoiceSendingSettings = async (
  companyId: UUID,
): Promise<InvoiceSendingSettings> => {
  return await vestigasApi
    .get(ENDPOINT.COMPANY.GET_COMPANY_INVOICE_SENDING_SETTINGS(companyId))
    .json<InvoiceSendingSettings>();
};
